/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Validation_Address_State_InvalidInputs */

const en_clients_validation_address_state_invalid = /** @type {(inputs: Clients_Validation_Address_State_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a valid state.`)
};

const pt_br2_clients_validation_address_state_invalid = /** @type {(inputs: Clients_Validation_Address_State_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione uma UF válida.`)
};

/**
* | output |
* | --- |
* | "Select a valid state." |
*
* @param {Clients_Validation_Address_State_InvalidInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_validation_address_state_invalid = /** @type {((inputs?: Clients_Validation_Address_State_InvalidInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Validation_Address_State_InvalidInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_validation_address_state_invalid(inputs)
	return pt_br2_clients_validation_address_state_invalid(inputs)
});